// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./NotoSansArabic-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./NotoSansArabic-Bold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Noto Sans Arabic Font Faces */
@font-face {
  font-family: 'Noto Sans Arabic';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Noto Sans Arabic';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}

/* Arabic text styling */
.arabic-text {
  font-family: 'Noto Sans Arabic', 'Arial Unicode MS', sans-serif;
  direction: rtl;
  text-align: right;
}`, "",{"version":3,"sources":["webpack://./src/assets/fonts/fonts.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;EACE,+BAA+B;EAC/B,+DAA2D;EAC3D,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,+DAAwD;EACxD,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,+DAA+D;EAC/D,cAAc;EACd,iBAAiB;AACnB","sourcesContent":["/* Noto Sans Arabic Font Faces */\n@font-face {\n  font-family: 'Noto Sans Arabic';\n  src: url('./NotoSansArabic-Regular.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Noto Sans Arabic';\n  src: url('./NotoSansArabic-Bold.ttf') format('truetype');\n  font-weight: bold;\n  font-style: normal;\n  font-display: swap;\n}\n\n/* Arabic text styling */\n.arabic-text {\n  font-family: 'Noto Sans Arabic', 'Arial Unicode MS', sans-serif;\n  direction: rtl;\n  text-align: right;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
